.root {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  padding-block: 2rem;

  .header {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    align-items: center;
    justify-content: center;
  }

  .heading,
  .lede,
  .error {
    max-width: 500px;
    text-align: center;
    text-wrap: balance;
  }

  .error {
    margin-top: 0.25rem;
  }

  .iconContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    background-color: var(--sentiment-negative);
    border-radius: 50%;

    .icon {
      color: white;
    }
  }
}
